import styled from "@emotion/styled";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog as MuiDialog,
  Slide,
  SlideProps,
  Stack,
} from "@mui/material";
import React, { Component } from "react";
import CloseIcon from "../../resources/icons-close.svg";
import ActionsContainer from "../buttons/ActionsContainer";
import Button from "../buttons/Button";
import BreakpointTemplate from "../templates/BreakpointTemplate";

export default class Dialog extends Component<any> {
  static defaultProps = {
    topCloseButton: true,
    disableEnforceFocus: false,
    disableScrollLock: true,
  };

  static Transition = React.forwardRef<unknown, SlideProps>(
    function Transition(props, ref) {
      return (
        <Slide direction="up" ref={ref} {...props}>
          {props.children}
        </Slide>
      );
    },
  );

  constructor(props: any) {
    super(props);

    this.state = {
      open: this.props.open ? this.props.open : false,
      loadingModel: null, //new LoadingModel()
    };
  }

  setLoading() {
    //this.loadingModel.setLoading(event, loading);
    //if (this.loadingBar) this.loadingBar.current.setLoading(this.loadingModel.isLoading);
  }

  open(open: any) {
    this.setState({ open: open !== undefined ? open : true });
  }

  close() {
    this.setState({ open: false });
  }

  onBackdropClick() {}

  onClose(e: any, reason: any) {
    const { onClose } = this.props;
    if (reason === "backdropClick") return;
    if (onClose) onClose(e, reason);
  }

  render() {
    const {
      open,
      theme,
      fixedActions,
      onClose,
      fullWidth,
      className,
      title,
      children,
      maxWidth,
      maxHeight,
      actions,
      justifyActions,
      disabledToBreakpoint,
      topCloseButton,
      disableEnforceFocus,
      disableScrollLock,
    } = this.props;
    const disabled =
      disabledToBreakpoint &&
      theme &&
      theme.isBreakpointDown(disabledToBreakpoint);

    return (
      <StyledConfirmationDialog
        className={"klayo-dialog" + (className ? " " + className : "")}
        open={open}
        fullWidth={fullWidth || true}
        fullScreen={theme?.isBreakpointDown("md")}
        onBackdropClick={this.onBackdropClick.bind(this)}
        onClose={this.onClose.bind(this)}
        PaperProps={{
          sx: {
            borderRadius: {
              xs: "0!important",
              sm: "0!important",
              md: "16px!important",
            },
          },
        }}
        scroll={fixedActions ? "paper" : "body"}
        maxWidth={maxWidth}
        TransitionComponent={Dialog.Transition as any}
        disableScrollLock={disableScrollLock}
        disableEnforceFocus={disableEnforceFocus}
      >
        {title && (
          <DialogTitle
            sx={{
              fontSize: { xs: "20px", md: "24px" },
              lineHeight: { xs: "28px", md: "32px" },
              padding: { xs: "26px", md: "40px 40px 32px 40px" },
              letterSpacing: { xs: "-0.3px", md: "-0.5px" },
            }}
          >
            <Stack direction="row">
              <div style={{ flexGrow: 1 }}>{title}</div>

              {topCloseButton && (
                <Button
                  icon={<CloseIcon />}
                  onClick={onClose}
                  sx={{ display: { xs: "block", md: "none" } }}
                />
              )}
            </Stack>
          </DialogTitle>
        )}

        <DialogContent
          sx={{
            padding: { xs: "24px", md: "40px" },
            maxHeight: maxHeight ? maxHeight : "unset",
            fontSize: "16px",
          }}
        >
          <BreakpointTemplate
            theme={theme}
            disabledToBreakpoint={disabledToBreakpoint}
          >
            {children}
          </BreakpointTemplate>
        </DialogContent>

        {(actions || disabled) && (
          <DialogActions
            sx={{
              padding: { xs: "24px", md: "40px" },
            }}
          >
            <ActionsContainer
              actions={actions}
              justifyActions={justifyActions}
              disabled={disabled}
              onClose={onClose}
            />
          </DialogActions>
        )}
      </StyledConfirmationDialog>
    );
  }
}

const StyledConfirmationDialog = styled(MuiDialog)`
  .MuiDialogContent-root {
  }

  @media (max-width: 900px) {
    .MuiDialogContent-root {
      margin: 0px 26px 26px 26px;
      padding: 0px 0px 20px 0px;
    }
  }
`;
